import { z } from 'zod';

/**
 * Human wording for the validation issues forms hit most. The zod schemas are
 * generated from the API (no custom messages possible there), so the wording
 * lives here, once, for every form. Anything not matched falls back to zod's
 * default English messages.
 */
z.config({
  customError: (issue) => {
    if (issue.code === 'too_small' && issue.origin === 'string') {
      return issue.minimum === 1
        ? 'Required'
        : `Must be at least ${issue.minimum} characters`;
    }
    if (issue.code === 'too_big' && issue.origin === 'string') {
      return `Must be at most ${issue.maximum} characters`;
    }
    return undefined;
  },
});
